module.exports = __webpack_public_path__ + "xdomain.html";


/*****************
 ** WEBPACK FOOTER
 ** /mnt/jenkins/jobs/master/workspace/~/file-loader?name=xdomain.html!/mnt/jenkins/jobs/master/workspace/core/client/xdomain.html
 ** module id = 513
 ** module chunks = 0 1 2 3 5 11
 **/